import { CwtProp, CwtSchema } from "@cawita/core-front/api";
import { UploadFile } from "./upload-file.model";

@CwtSchema()
export class FileDictionary {
    @CwtProp({ ref: UploadFile }) fr?: UploadFile;
    @CwtProp({ ref: UploadFile }) en?: UploadFile;
}